"use strict";

/// <reference types="jquery"/>
$(function () {
    $(".type-fichier-container").each(function () {
        var $container = $(this);
        $container.find("table.datatable").on("preInit.dt", function (e, settings) {
            $container.addCheckBoxFilter("Dédié au workflow :", "inwf", settings);
        });
        $container.setDatatableAdmin();
    });
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/TypeFichier/index.ts
// module id = 612
// module chunks = 0